import { Fragment } from "react";
import { Popover, PopoverButton, PopoverPanel, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { twMerge } from "tailwind-merge";
import { navLinkBase } from "../../utils/styles";
import { MenuItem } from "./MenuItemRenderer";

interface DropdownMenuProps {
  item: MenuItem;
  className?: string;
}

export function DropdownMenu({ item, className = navLinkBase }: DropdownMenuProps) {
  if (!item.children) return null;

  return (
    <Popover className="relative">
      <PopoverButton className={twMerge(className, 'cursor-pointer gap-1 px-3 py-3 align-top')}>
        <span>{item.name}</span>
        <ChevronDownIcon
          className="h-5 w-5 flex-none text-white/80 hover:text-white"
          aria-hidden="true"
        />
      </PopoverButton>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-200"
        enterFrom="opacity-0 translate-y-1"
        enterTo="opacity-100 translate-y-0"
        leave="transition ease-in duration-150"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 translate-y-1"
      >
        <PopoverPanel className="absolute -left-8 top-full z-10 mt-3 w-screen max-w-md overflow-hidden rounded-3xl bg-white shadow-lg ring-1 ring-gray-900/5">
          <div className="p-4">
            {item.children.map((subItem) => (
              <div
                key={subItem.name}
                className="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm leading-6 hover:bg-gray-200"
              >
                <div className="flex-auto">
                  <a
                    href={subItem.href}
                    className="block font-semibold text-gray-900"
                  >
                    {subItem.name}
                    <span className="absolute inset-0" />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </PopoverPanel>
      </Transition>
    </Popover>
  );
}